import { profileSettingsReducerKey } from './ProfileSettingsConstants';

export function profileSettings(state) {
  return state.get(profileSettingsReducerKey);
}

export function isLoading(state) {
  return profileSettings(state).get('isLoading');
}
